import React, {useState} from "react";
import {ModelPolicy} from "../../modal/policy/ModelPolicy";
import {ModelRules} from "../../modal/rules/ModelRules";

export const FooterPolicy = () => {
    const [isModalPolicyOpen, setIsModalPolicyOpen] = useState(false);
    const [isModalRulesOpen, setIsModalRulesOpen] = useState(false);

    const openModalPolicy = () => {
        setIsModalPolicyOpen(true);
    }

    const closeModalPolisy = () => {
        setIsModalPolicyOpen(false);
    }

    const openModalRules = () => {
        setIsModalRulesOpen(true);
    }

    const closeModalRules = () => {
        setIsModalRulesOpen(false);
    }

    return (
        <>
            <div className="footer__policy">
                <a className="doc" onClick={openModalPolicy}>
                    Политика конфиденциальности
                </a>
                <a className="doc"
                   href="https://cloud.mail.ru/public/JKDR/c9LVZKiJX"
                   target="_blank">
                    Договор оферты
                </a>
                <a className="doc" onClick={openModalRules}>
                    Наши правила
                </a>
            </div>
            <ModelPolicy isOpen={isModalPolicyOpen} onClose={closeModalPolisy}/>
            <ModelRules isOpen={isModalRulesOpen} onClose={closeModalRules}/>
        </>

    )
}